export default function ArrowDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.0001 11.3334L3.3813 6.33343L12.6189 6.33343L8.0001 11.3334Z" fill="currentColor" />
    </svg>
  );
}
